var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('Spinner'):_vm._e(),_vm._l((_vm.replies),function(reply){return _c('Reply',{key:reply.id,attrs:{"initial-reply":reply}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }